export default __webpack_public_path__ + "static/media/KK_logo_keskitetty_sf_swe_rgb_black.2ea8eb24.png";